// extracted by mini-css-extract-plugin
var _1 = "CommentPreviewText-module__animateUploadProgressBarWidth--TwAnJ";
var _2 = "CommentPreviewText-module__animatedBackground--PKRV4";
var _3 = "CommentPreviewText-module__container--dnofI";
var _4 = "CommentPreviewText-module__content--P7q9C";
var _5 = "CommentPreviewText-module__isCommentQuote--qGOhv";
var _6 = "CommentPreviewText-module__mention--a5Qz2";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "isCommentQuote", _6 as "mention" }
